<template>
  <el-dialog :title="defaultTitle" :visible.sync="visible" :close-on-click-modal="false">
    <SelectCustomer @selected="handleSelect"></SelectCustomer>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">{{$t('common.Cancel')}}</el-button>
      <el-button type="primary" @click="addCustomer">{{$t('common.Add')}}</el-button>
    </span>
  </el-dialog>
</template>
<script>

import SelectCustomer from './select-customer'

export default {
	name: 'SearchCustomerDialog',
  props: {
    visible : {type : Boolean},
    title : {type : String},

	},
	data() {
		return {
      model : {
        customer : null
      },
      searchedCustomers : [],
      loading : false
	   }
   },
  computed: {
    defaultTitle () {
      if (this.title == null) {
        return this.$i18n.t('clients.searchCustomer');
      }

      return this.title;
    },
  },
  components : {
    SelectCustomer
  },
  methods : {
    handleSelect(customer){
      this.model.customer = customer;
    },
    close(){
      this.$emit('close');
    },
    addCustomer(){
      this.$emit('select', this.model.customer);
      this.close();
    }
  },
  created(){

  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/_variables';

</style>
